var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatGroupIconButtonActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 22,
    viewBox: "0 0 6 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.24967C1.35 8.24967 0 9.48717 0 10.9997C0 12.5122 1.35 13.7497 3 13.7497C4.65 13.7497 6 12.5122 6 10.9997C6 9.48717 4.65 8.24967 3 8.24967ZM3 -0.000328064C1.35 -0.000328064 0 1.23717 0 2.74967C0 4.26217 1.35 5.49967 3 5.49967C4.65 5.49967 6 4.26217 6 2.74967C6 1.23717 4.65 -0.000328064 3 -0.000328064ZM3 16.4997C1.35 16.4997 0 17.7372 0 19.2497C0 20.7622 1.35 21.9997 3 21.9997C4.65 21.9997 6 20.7622 6 19.2497C6 17.7372 4.65 16.4997 3 16.4997Z",
    fill: "#6E6E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGroupIconButtonActive);
export default __webpack_public_path__ + "static/media/chatGroupIconButtonActive.40f4f592.svg";
export { ForwardRef as ReactComponent };